import { observer } from 'mobx-react';
import { sortDirection, valueFor } from '../../../../../ListFilter';
import { SearchParameters } from '../../../../../ListFilter/Types';
import MulticheckControls from '../../../../../Multicheck/MulticheckControls';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import SortableColumn from '../../../../SortableColumn';
import { SortableColumn as SortableColumnType } from '../../Invitations/Store/Types';
import { InvitationResource } from '../Store/Types';

interface Props {
  multicheckStore: MulticheckStore<InvitationResource>;
  searchParameters: SearchParameters;
  sorting: (sortedColumn: SortableColumnType) => void;
}

function Head({ sorting, multicheckStore, searchParameters }: Props) {
  return (
    <thead className="bg-gray-50">
      <tr>
        <th className="w-24 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
          <MulticheckControls store={multicheckStore} />
        </th>
        <SortableColumn
          columnName={'Full Name'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('name')}
          sortKey="name"
          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        />
        <SortableColumn
          columnName={'Email'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('email')}
          sortKey="email"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <SortableColumn
          columnName={'Last Collection Email Date'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('send_date')}
          sortKey="send_date"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <SortableColumn
          columnName={'Last Collection Access Date'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('access_status')}
          sortKey="access_status"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <SortableColumn
          columnName={'Total Enrollments'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('total_enrollments')}
          sortKey="total_enrollments"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <th className="px-3 py-3.5" />
      </tr>
    </thead>
  );
}

export default observer(Head);
